import { whiteLabel } from 'Lib/white-label/white-label';

const $body = $('body');
const $choiceLocationValue = $('.pay-and-delivery__choice-location-value');

function setLocationOnTitle() { // Установка названия города в заголовок
    $choiceLocationValue.text(whiteLabel.city);
}

setLocationOnTitle();
$body.on('changeCity.wl', setLocationOnTitle);
$choiceLocationValue.on('click', whiteLabel.showCitiesPopup); // Клик на текущую локацию в строке "Ваш населённый пункт..."